import { jsx as a, jsxs as J } from "react/jsx-runtime";
import { forwardRef as $, useState as d, useEffect as j } from "react";
import p from "./styles.module.less.js";
const A = $(
  (y, S) => {
    var g;
    const { value: m = {}, onChange: l, disabled: N, error: C } = y, [r, f] = d(m.year || ""), [o, I] = d(m.month || ""), [c, h] = d(m.day || ""), [M, v] = d([
      "day",
      "month",
      "year"
    ]);
    j(() => {
      O();
    }, []);
    const D = (n, e) => new Date(n, e, 0).getDate(), b = (n) => {
      const e = n.target.value, t = parseInt(e, 10), u = parseInt(r, 10), i = parseInt(o, 10);
      if (!isNaN(t) && !isNaN(u) && !isNaN(i)) {
        const s = D(u, i);
        t >= 1 && t <= s && (h(e), l({ year: r, month: o, day: e }));
      } else (e === "" || !isNaN(t) && t < 31 && !r && !o) && (h(e), l({ year: r, month: o, day: e }));
    }, w = (n) => {
      const e = n.target.value, t = parseInt(e, 10), u = parseInt(r, 10), i = parseInt(c, 10);
      if (!isNaN(t) && t >= 1 && t <= 12) {
        I(e), l({ year: r, month: e, day: c });
        const s = D(u, t);
        !isNaN(i) && i > s && (h(s.toString()), l({ year: r, month: e, day: s.toString() }));
      } else e === "" && (I(e), l({ year: r, month: e, day: c }));
    }, x = (n) => {
      const e = n.target.value, t = parseInt(e, 10), u = parseInt(o, 10), i = parseInt(c, 10);
      if (isNaN(t))
        e === "" && (f(e), l({ year: e, month: o, day: c }));
      else {
        f(e), l({ year: e, month: o, day: c });
        const s = D(t, u);
        !isNaN(i) && i > s && (h(s.toString()), l({ year: e, month: o, day: s.toString() }));
      }
    }, O = () => {
      const t = new Date(1999, 11, 31).toLocaleDateString().split(/\D/);
      parseInt(t[0], 10) === 31 ? v(["day", "month", "year"]) : parseInt(t[0], 10) === 1999 ? v(["year", "month", "day"]) : v(["month", "day", "year"]);
    }, Y = () => M.map((n, e) => n === "day" ? /* @__PURE__ */ a(
      "input",
      {
        type: "text",
        value: c,
        onChange: b,
        placeholder: "Day",
        className: p.splitDateInput,
        disabled: N
      },
      e
    ) : n === "month" ? /* @__PURE__ */ J("select", { value: o, onChange: w, className: p.splitDateInput, disabled: N, children: [
      /* @__PURE__ */ a("option", { value: "", children: "Month" }),
      /* @__PURE__ */ a("option", { value: "1", children: "January" }),
      /* @__PURE__ */ a("option", { value: "2", children: "February" }),
      /* @__PURE__ */ a("option", { value: "3", children: "March" }),
      /* @__PURE__ */ a("option", { value: "4", children: "April" }),
      /* @__PURE__ */ a("option", { value: "5", children: "May" }),
      /* @__PURE__ */ a("option", { value: "6", children: "June" }),
      /* @__PURE__ */ a("option", { value: "7", children: "July" }),
      /* @__PURE__ */ a("option", { value: "8", children: "August" }),
      /* @__PURE__ */ a("option", { value: "9", children: "September" }),
      /* @__PURE__ */ a("option", { value: "10", children: "October" }),
      /* @__PURE__ */ a("option", { value: "11", children: "November" }),
      /* @__PURE__ */ a("option", { value: "12", children: "December" })
    ] }, e) : n === "year" ? /* @__PURE__ */ a(
      "input",
      {
        type: "text",
        value: r,
        onChange: x,
        placeholder: "Year",
        className: p.splitDateInput,
        disabled: N
      },
      e
    ) : null);
    return /* @__PURE__ */ a(
      "div",
      {
        ref: S,
        ...y.props,
        className: `${p.splitDateInputWrapper} ${(g = y.props) == null ? void 0 : g.className} ${C ? p.error : ""}`,
        children: Y()
      }
    );
  }
);
A.displayName = "SplitDateInput";
export {
  A as SplitDateInput
};
